import DeleteSubClient from '../DeleteSubClient/DeleteSubClient'
import UpdateSubClientAccess from '../UpdateSubClientAccess/UpdateSubClientAccess'
import './SubClientListItem.css'

export default function SubClientListItem({user, client, subClient, updateSubClients, toggleNotifications}) {
  return (
    <div className='SubClientListItem'>
        <div className='leftSection'>
            <div className='email'>
                {subClient.email}
            </div>
        </div>
        <div className='rightSection'>
            <UpdateSubClientAccess user={user} client={client} subClient={subClient} updateSubClients={updateSubClients} toggleNotifications={toggleNotifications} />
            <DeleteSubClient user={user} subClient={subClient} updateSubClients={updateSubClients} toggleNotifications={toggleNotifications} />
        </div>
    </div>
  )
}
